var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"voerro-notification",class:("voerro-notification-theme-" + _vm.theme),domProps:{"innerHTML":_vm._s(_vm.text)},on:{"click":function($event){return _vm.hide($event.target)}}})}
var staticRenderFns = []

export { render, staticRenderFns }